module.exports = __webpack_public_path__ + "static/media/0.5ea09f8f.jpg";